// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3P-R5","header":"PatientQuestionnaire_header__f6lxQ","info":"PatientQuestionnaire_info__23XS9"};